import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiCustom from "../../utils/ApiCustom";
import { formatCurrencyVND } from "../../utils/helps";
import ConfirmModal from "../../components/ConfirmModal.js";
import { toast } from "react-toastify";
import { GiftIcon } from "@heroicons/react/24/solid";
import { HomeIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function ProductDetailPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    getData();
  }, []);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalUser, setIsOpenModalUser] = useState(false);
  const [isOpenModalProduct, setIsOpenModalProduct] = useState(false);
  const [cartChange, setCartChange] = useState([]);
  const [coupon, setCoupon] = useState("");
  const [codeCoupon, setCodeCoupon] = useState("");
  const [discount, setDiscount] = useState(null);

  const handleCloseModal = () => {
    setIsOpenModal(false);
    setCartChange([]);
  };

  const handleCloseModalUser = () => {
    setIsOpenModalUser(false);
  };

  const handleCloseModalProduct = () => {
    setIsOpenModalProduct(false);
  };

  const getData = () => {
    ApiCustom.get(`product-show/` + slug)
      .then((res) => {
        if (!res.data.data) {
          setLoading(false);
          return;
        }
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center">
        <div className="text-center text-lg font-semibold">Loading...</div>
      </div>
    );
  }

  if (data == null) {
    return (
      <div className="flex justify-center items-center">
        <div className="text-center text-lg font-semibold">
          Sản phẩm không tồn tại!
        </div>
      </div>
    );
  }

  const handleOpenModal = (cart) => {
    setCartChange((prev) => [...prev, cart]);
    setIsOpenModal(true);
  };

  const handleSubmitCart = () => {
    localStorage.setItem("cart", JSON.stringify(cartChange));
    setCartChange([]);
    handleCloseModal();
    navigate("/gio-hang");
  };

  const handleCoupon = () => {
    ApiCustom.get("/coupon-show-by-code/" + coupon)
      .then((res) => {
        const couponData = res.data.data;
        const now = new Date();
        if (couponData.userId != userId) {
          toast.error("Mã thưởng không hợp lệ hoặc đã hết hạn");
          return;
        }
        if (couponData.productId != data.id) {
          toast.error("Mã của bạn không thể dùng cho sản phẩm này");
          return;
        }
        if (couponData.status != "active") {
          toast.error("Mã của bạn đã được sử dụng");
          return;
        }
        if (
          now < new Date(couponData.startDate) ||
          now > new Date(couponData.endDate)
        ) {
          toast.error("Mã của bạn đã hết hạn");
          return;
        }
        setCoupon("");
        setDiscount(couponData);
        setCodeCoupon(couponData.code);
        setQuantity(1);
        toast.success("Áp dụng mã thưởng thành công");
      })
      .catch((err) => {
        console.log(err);
        toast.error("Mã thưởng không hợp lệ hoặc đã hết hạn");
      });
  };

  const handleDeleteCoupon = () => {
    setDiscount(null);
    setCodeCoupon("");
    setCoupon("");
    toast.success("Huỷ mã thưởng thành công");
  };

  const handleContact = (formData) => {
    const postData = {
      ...formData,
      companyId: data.company?.id,
      productId: data.id,
    };

    ApiCustom.post("/contact-create", postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.data.data?.status == 200) {
          toast.success("Liên hệ đặt hàng thành công");
          handleCloseModalUser();
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 flex-wrap">
          <li className="inline-flex items-center">
            <Link to="/" className="inline-flex items-center hover:text-blue-600 font-medium">
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <Link to="/danh-sach-san-pham" className="ml-1 hover:text-blue-600 font-medium">
                Sản phẩm
              </Link>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium truncate max-w-[200px]">{data.name}</span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-4 mb-4">
        <div className="col-span-1 border w-full aspect-[5/4] border-gray-300 rounded-lg overflow-hidden mb-4">
          <img
            src={data.urlImage}
            alt="Product Image"
            className="w-full h-full object-cover rounded-lg shadow-md"
          />
        </div>
        
        <div className="col-span-2 gap-4 border border-gray-300 rounded-lg p-4">
          <h1 className="text-3xl font-bold">{data.name}</h1>

          <div className="flex items-center mt-4">
            <label className="mr-2 font-medium whitespace-nowrap">
              Đơn vị cung cấp:
            </label>
            <p>{data.company.companyName}</p>
          </div>

          <div className="flex items-center mt-4">
            <label className="mr-2 font-medium">Danh mục hàng hóa:</label>
            <p>{data?.category?.name}</p>
          </div>

          <div className="flex items-center mt-4">
            <label className="mr-2 font-medium">Giá:</label>
            {data.discountPrice && Number(data.discountPrice) != 0 ? (
              <div className="flex items-center justify-start gap-4">
                <p className="text-xl font-semibold text-gray-500 line-through">
                  {formatCurrencyVND(data.price)} 
                </p>
                <p className="text-2xl font-semibold text-red-500">
                  {discount
                    ? formatCurrencyVND(
                        Number(data.discountPrice) - discount.price
                      )
                    : formatCurrencyVND(Number(data.discountPrice))}
                  {" / " + data.unit}
                </p>
                {discount && (
                  <p className="text-lg font-semibold text-gray-500">
                    ({codeCoupon})
                  </p>
                )}
              </div>
            ) : (
              <div className="flex items-center justify-start gap-4">
                <p className="text-2xl font-semibold text-red-500">
                  {discount
                    ? formatCurrencyVND(data.price - discount.price)
                    : formatCurrencyVND(data.price)}
                  {" / " + data.unit}
                </p>
                {discount && (
                  <p className="text-lg font-semibold text-gray-500">
                    ({codeCoupon})
                  </p>
                )}
              </div>
            )}
          </div>

          {data.gift && data.giftCondition && (
            <div className="flex items-center  mt-4">
              <GiftIcon className="w-5 h-5 animate-rgb-glow  mr-2" />
              <label className="font-medium ">
                {data.gift} khi tổng giá trị sản phẩm đạt{" "}
                {formatCurrencyVND(data.giftCondition)}
              </label>
            </div>
          )}

          <div className="flex items-center mt-4">
            <label className="mr-2 font-medium">Số lượng đặt hàng:</label>
            <input
              type="number"
              min="1"
              value={quantity}
              className="w-16 px-2 py-1 border rounded-lg text-center"
              onChange={(e) => {
                if (discount) {
                  toast.error(
                    "bạn không thể tăng số lượng khi đang áp dụng mã thưởng"
                  );
                  return;
                }
                setQuantity(Number(e.target.value));
              }}
            />
          </div>

          <div className="flex items-center mt-4 gap-2 flex-wrap">
            <label className="font-medium whitespace-nowrap">Mã thưởng BCCU:</label>
            <input
              type="text"
              value={coupon}
              className="w-48 px-2 py-2 border rounded-lg text-center"
              onChange={(e) => {
                setCoupon(e.target.value);
              }}
            />
            <div className="flex items-center gap-2">
              <button
                className="px-3 py-2 bg-base-100 text-base rounded-lg hover:bg-base-300"
                onClick={handleCoupon}
              >
                Áp dụng
              </button>
              <button
                className="px-3 py-2 bg-base-100 text-base rounded-lg hover:bg-base-300"
                onClick={handleDeleteCoupon}
              >
                Huỷ bỏ
              </button>
            </div>
          </div>

          <button
            className="mt-6 bg-blue-500 hover:bg-blue-600 text-white font-medium px-6 py-2 rounded-lg shadow-md"
            onClick={(event) => {
              event.preventDefault();

              const userId = localStorage.getItem("userId");
              if (!userId) {
                setIsOpenModalUser(true);
                return;
              }

              if (data.company.userId == userId) {
                setIsOpenModalProduct(true);
                return;
              }

              const cart = JSON.parse(localStorage.getItem("cart")) || [];

              const newProduct = {
                id: data.id,
                company: data.companyId,
                image: data.urlImage,
                name: data.name,
                price: Number(data.discountPrice)
                  ? Number(data.discountPrice)
                  : data.price,
                coupon: discount,
                quantity: quantity,
                gift: data.gift,
                condition: Number(data.giftCondition),
              };

              if (cart.length > 0) {
                const hasDifferentCompany = cart.some(
                  (item) => item.company !== newProduct.company
                );

                if (hasDifferentCompany) {
                  handleOpenModal(newProduct);
                  return;
                }
              }

              let isProductExist = false;
              let updatedCart = cart.map((item) => {
                if (item.id === newProduct.id) {
                  isProductExist = true;
                  return {
                    ...newProduct,
                    company: newProduct.company,
                    image: newProduct.image,
                    name: newProduct.name,
                    price: newProduct.price,
                    coupon: newProduct.coupon,
                    quantity: item.quantity + newProduct.quantity,
                    gift: newProduct.gift,
                    condition: newProduct.condition,
                  };
                }
                return item;
              });

              if (!isProductExist) {
                updatedCart.push(newProduct);
              }

              localStorage.setItem("cart", JSON.stringify(updatedCart));
              navigate("/gio-hang");
            }}
          >
            {/* Thêm vào giỏ hàng */}
            {userId ? "Đặt hàng" : "Liên hệ"}
          </button>
        </div>
      </div>

      <div className="gap-4 border border-gray-300 rounded-lg p-4">
        <h2 className="text-xl font-bold">Mô tả sản phẩm</h2>

        <div className="mt-2"
          dangerouslySetInnerHTML={{ __html: data?.description || "Không có mô tả." }}
        />
      </div>

      <ConfirmModal
        isOpen={isOpenModal}
        onClose={handleCloseModal}
        onSubmit={handleSubmitCart}
        message={
          "Bạn chỉ có thể thêm sản phẩm từ cùng một công ty. \n Bạn có muốn xoá sản phẩm trong giỏ hàng không?"
        }
      />

      <ConfirmModal
        isOpen={isOpenModalUser}
        onClose={handleCloseModalUser}
        message={"Vui lòng nhập thông tin liên hệ để đặt hàng"}
        isForm={true}
        onSubmit={handleContact}
        title="Liên hệ"
      />

      <ConfirmModal
        isOpen={isOpenModalProduct}
        onClose={handleCloseModalProduct}
        message={"Bạn không thể mua sản phẩm của chính mình"}
      />
    </div>
  );
}
